<template>
  <div class="camera" v-on="$listeners">
    <img
      :src="stream"
      alt="Stream"
      data-video-stream
      class="camera__player"
    />
    <div
      v-if="label"
      v-text="label"
      class="camera__label"
    />
    <div
      v-if="$slots.overlay"
      class="camera__overlay"
    >
      <slot name="overlay" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Camera',
  props: {
    stream: {
      type: String,
      default: process.env.VUE_APP_VIDEO_STREAM,
    },
    label: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="stylus">
.camera
  position relative
  display block
  width 100%
  height 100%
  background-color #000

  &__player
    display block
    width 100%
    height 100%
    object-fit contain

  &__label
    abs bottom 3% left 50%
    background-color $c_border
    color $c_primary
    padding 1em 2em
    border-radius 0.2em
    opacity 0.9
    pointer-events none
    transform translate(-50%, 0)

  &__overlay
    abs top left right bottom
    z-index 3

  &__image
    width 100%
    height 100%
    background-color inherit
    img
      display block
      height 100%
      margin 0 auto
</style>
